import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    pagoImpuestos: false,
    incluirImpuestosOrganismo: false,
    pagoCuotasPlan: false,
    controller: 'pagos',

    id: 0,
    fechaContable: moment(new Date()).format('YYYY-MM-DD'),
    proveedorId: 0,
    proveedor: {},
    proveedorNombre: null,
    impuestoOrganismoId: 0,
    impuestoOrganismoNombre: null,
    planPagosId: 0,
    planPagosNumero: '',
    monedaId: 0,
    monedaNombre: null,
    cotizacion: 0,
    // cotizacionEnabled: Boolean(false),
    /*total: 0,*/
    observaciones: '',

    cuentaCorriente: [],
    cuentaCorrienteDisplay: [],

    totalSeleccionado: 0,
    cantidadSeleccionados: 0,

    totalCuentaCorrientePesos: 0,
    totalSeleccionadoPesos: 0,
    totalCuentaCorrienteDolares: 0,
    totalSeleccionadoDolares: 0,

    /* Pago de cuotas de un plan de pagos */
    planPagoCuotas: [],
    planPagosCuotasDisplay: [],

    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    /* Documentos */
    pesos: 0,
    importeChequesPropiosPesos: 0,
    importeChequesPropiosDolares: 0,
    chequesPropios: [],
    importeTransferenciasProveedoresPesos: 0,
    importeTransferenciasProveedoresDolares: 0,
    transferenciasProveedores: [],
    importeTarjetasCuponesPesos: 0,
    importeTarjetasCuponesDolares: 0,
    tarjetasCupones: [],
    importePagosVepPesos: 0,
    importePagosVepDolares: 0,
    pagosVep: [],
    importePlanesPagosPesos: 0,
    importePlanesPagosDolares: 0,
    planesPagos: [],
    importeRetencionesClientesPesos: 0,
    retencionesClientes: [],
    importeRetencionesProveedoresPesos: 0,
    retencionesProveedores: [],

    /* Caja */
    cajaRegistroId: 0,
    cajaRegistro: null,
    cajaRegistroNombre: null,

    /* Cuenta corriente seleccionada para dejar el saldo */
    cuentaCorrienteSaldoId: 0,

    pagoDatos: [],
    pagoComprobantes: [],
    pagoCuotas: [],
    pagoDocumentos: [],
    pagoChequesPropios: [],
    pagoTarjetasCupones: [],
    pagoTransferenciasProveedores: [],
    pagoRetencionesProveedores: [],
    pagoVeps: [],
    pagoPlanesPagos: []
};

const mutations = {
    updateField,

    'INICIALIZAR_PAGO' (state, params) {
        state.pagoImpuestos = params.pagoImpuestos;
        if (params.pagoImpuestos) {
            state.controller = 'pagos-impuestos';
        } else {
            state.controller = 'pagos';
        }
        state.incluirImpuestosOrganismo = false;
        state.pagoCuotasPlan = (/true/i).test(params.pagoCuotasPlan);

        state.id = 0;
        state.fechaContable = moment(new Date()).format('YYYY-MM-DD'),
        state.proveedorId= 0;
        state.proveedor= null;
        state.proveedorNombre= null;
        state.impuestoOrganismoId = 0;
        state.impuestoOrganismoNombre = null;
        state.planPagosId = params.planPagosId || 0;
        state.planPagosNumero = '';        
        /*state.total = 0;*/
        state.monedaId= 101;
        state.monedaNombre = 'PESOS';
        state.cotizacion = 1;
        state.observaciones = '';

        state.cuentaCorriente= [];
        state.cuentaCorrienteDisplay = [];

        state.planPagoCuotas = [];
        state.planPagosCuotasDisplay = [];

        inicializarDocumentos (state);

        calcularTotalesCuentaCorriente(state);

        calcularTotalesCuotas(state);

        state.cajaRegistroId = 0;
        state.cajaRegistro = null;
        state.cajaRegistroNombre = null;
    
        state.cuentaCorrienteSaldoId = 0;
    },
    'INICIALIZAR_DOCUMENTOS'(state) {
        inicializarDocumentos (state);
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.proveedor = proveedor;
        state.proveedorId = proveedor? proveedor.id : 0;
        state.proveedorNombre = proveedor? proveedor.nombre.trim() : null;
        state.impuestoOrganismoId = 0;
        state.impuestoOrganismoNombre = null;

        if ((/true/i).test(state.pagoImpuestos)) {
            state.impuestoOrganismoId = proveedor? proveedor.impuestoOrganismoId : null;
            state.impuestoOrganismoNombre = proveedor? proveedor.impuestoOrganismo.trim() : null;
        }
        state.incluirImpuestosOrganismo = false;
    },
    'SET_CUENTA_CORRIENTE'(state, cuentaCorriente) {
        state.cuentaCorriente = [];
        state.cuentaCorrienteDisplay = [];

        state.cuentaCorriente = cuentaCorriente.map(cuentaCorriente => ({
            ...cuentaCorriente,
            rowVersion: cuentaCorriente.rowVersion,
            selected: Boolean(false),
            seleccionDisabled: Boolean(false),
            _rowVariant: ''
        }))

        state.cuentaCorrienteDisplay = [...state.cuentaCorriente];

        state.paginaActual = 1;
        state.totalRegistros = state.cuentaCorrienteDisplay.length;

        calcularTotalesCuentaCorriente(state);

        /* Parámetros del pago */
        // state.proveedorId= 0;
        // state.proveedorNombre = null;
        state.monedaId= 0;
        state.monedaNombre = null;
        state.cotizacion = 1;
    },
    'SELECCIONAR_CUENTA_CORRIENTE' (state, cuentaCorrienteId) {
        /* Buscamos la info del item seleccionado para filtrar los comprobantes */
        let item = state.cuentaCorriente
            .find(ccp => ccp.id == cuentaCorrienteId);

        if (item) {
            if (item.selected) {
                /* Seleccionamos los parametros de la orden de pago */
                if (state.monedaId == 0) {
                    state.monedaId= item.monedaId;
                    state.monedaNombre = item.moneda;
                    state.cotizacion = 1;

                    // if (state.monedaId == 101) {
                    //     state.cotizacionEnabled = Boolean(false);
                    // } else {
                    //     state.cotizacionEnabled = Boolean(true);
                    // }
                }
            }
        }

        calcularTotalesCuentaCorriente(state);

        if (!state.cantidadSeleccionados) {
            state.monedaId= 0;
            state.monedaNombre = null;
            state.cotizacion = 0;
            // state.cotizacionEnabled = Boolean(false);
        } 

        state.cuentaCorriente.forEach(cuentaCorriente => {
            let disabled = false;

            if (cuentaCorriente.monedaId != 0) {
                if (state.monedaId != 0 & cuentaCorriente.monedaId != state.monedaId) {
                    disabled = true;
                }
            }

            if (disabled) {
                cuentaCorriente.seleccionDisabled = Boolean(true),
                cuentaCorriente._rowVariant = 'danger';
            } else {
                cuentaCorriente.seleccionDisabled = Boolean(false),
                cuentaCorriente._rowVariant = '';
            }
        });

        state.cuentaCorrienteDisplay = [...state.cuentaCorriente];
    },
    'VALIDAR_MONEDA' (state) {
        /* Si no hay comprobantes seleccionados, selecciono pesos como moneda */
        if (state.totalSeleccionadoPesos == 0 & state.totalSeleccionadoDolares == 0) {
            state.monedaId= 101;
            state.monedaNombre = 'PESOS';
            state.cotizacion = 1;
        }
    },

    'SET_PLAN'(state, planPagos) {
        state.proveedor = {
            id: planPagos.proveedorId,
            nombre: planPagos.proveedor
        };
        state.proveedorId = planPagos.proveedorId;
        state.proveedorNombre = planPagos.proveedor;
        state.impuestoOrganismoId = planPagos.impuestoOrganismoId;
        state.impuestoOrganismoNombre = planPagos.impuestoOrganismo;
        state.planPagosNumero = planPagos.numero;

        state.planPagoCuotas = [];
        state.planPagosCuotasDisplay = [];

        state.planPagoCuotas = planPagos.cuotas.map(planPagoCuota => ({
            ...planPagoCuota,
            capitalSelected: Boolean(false),
            interesesSelected: Boolean(false),
            interesesResarcitoriosSelected: Boolean(false),
            capitalSeleccionDisabled: planPagoCuota.capitalDisabled,
            interesesSeleccionDisabled: planPagoCuota.interesesDisabled,
            interesesResarcitoriosSeleccionDisabled: planPagoCuota.interesesResarcitoriosDisabled,
            _rowVariant: ''
        }))

        state.planPagosCuotasDisplay = [...state.planPagoCuotas];

        state.paginaActual = 1;
        state.totalRegistros = state.planPagosCuotasDisplay.length;

        calcularTotalesCuotas(state);

        state.monedaId= planPagos.monedaId || 101;
        state.monedaNombre = planPagos.moneda || 'PESOS';
        state.cotizacion = 1;
    },
    'SELECCIONAR_CUOTA' (state, planPagosCuotaId) {
        
        calcularTotalesCuotas(state);
    },

    'SET_CAJA_REGISTRO' (state, cajaRegistro) {
        state.cajaRegistro = cajaRegistro;
        state.cajaRegistroId = 0;
        state.cajaRegistroNombre = null;
        if (cajaRegistro) {
            if (cajaRegistro.id) {
                state.cajaRegistroId = cajaRegistro.id;
            }
            if (cajaRegistro.nombre) {
                state.cajaRegistroNombre = cajaRegistro.nombre.toUpperCase().trim();
            }
        }
    },

    'SET_CHEQUE_PROPIO' (state, chequePropio) {
        chequePropio.proveedorId = state.proveedorId;
        chequePropio.proveedor = state.proveedor;
        
        state.chequesPropios.push(chequePropio);

        if (state.chequesPropios.length != 0) {
            state.importeChequesPropiosPesos = state.chequesPropios
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeChequesPropiosDolares = state.chequesPropios
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeChequesPropiosPesos = 0;
            state.importeChequesPropiosDolares = 0;
        }
    },
    'DELETE_CHEQUE_PROPIO' (state, chequePropio) {
        let itemKey = state.chequesPropios
            .findIndex(cheque => cheque == chequePropio);

        if (itemKey != -1) {
            state.chequesPropios.splice(itemKey, 1);
        }

        if (state.chequesPropios.length != 0) {
            state.importeChequesPropiosPesos = state.chequesPropios
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeChequesPropiosDolares = state.chequesPropios
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeChequesPropiosPesos = 0;
            state.importeChequesPropiosDolares = 0;
        }
    },

    'SET_TRANSFERENCIA_PROVEEDOR' (state, transferenciaProveedor) {
        transferenciaProveedor.proveedorId = state.proveedorId;
        transferenciaProveedor.proveedor = state.proveedor;
        
        state.transferenciasProveedores.push(transferenciaProveedor);

        if (state.transferenciasProveedores.length != 0) {
            state.importeTransferenciasProveedoresPesos = state.transferenciasProveedores
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasProveedoresDolares = state.transferenciasProveedores
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeTransferenciasProveedoresPesos = 0;
            state.importeTransferenciasProveedoresDolares = 0;
        }
    },
    'DELETE_TRANSFERENCIA_PROVEEDOR' (state, transferenciaProveedor) {
        let itemKey = state.transferenciasProveedores
            .findIndex(transferencia => transferencia == transferenciaProveedor);

        if (itemKey != -1) {
            state.transferenciasProveedores.splice(itemKey, 1);
        }

        if (state.transferenciasProveedores.length != 0) {
            state.importeTransferenciasProveedoresPesos = state.transferenciasProveedores
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasProveedoresDolares = state.transferenciasProveedores
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeTransferenciasProveedoresPesos = 0;
            state.importeTransferenciasProveedoresDolares = 0;
        }
    },

    'SET_PAGO_VEP' (state, pagoVep) {
        pagoVep.proveedorId = state.proveedorId;
        pagoVep.proveedor = state.proveedor;
        
        state.pagosVep.push(pagoVep);

        if (state.pagosVep.length != 0) {
            state.importePagosVepPesos = state.pagosVep
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importePagosVepDolares = state.pagosVep
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importePagosVepPesos = 0;
            state.importePagosVepDolares = 0;
        }
    },
    'DELETE_PAGO_VEP' (state, pagoVep) {
        let itemKey = state.pagosVep
            .findIndex(item => item == pagoVep);

        if (itemKey != -1) {
            state.pagosVep.splice(itemKey, 1);
        }

        if (state.pagosVep.length != 0) {
            state.importePagosVepPesos = state.pagosVep
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importePagosVepDolares = state.pagosVep
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importePagosVepPesos = 0;
            state.importePagosVepDolares = 0;
        }
    },

    'SET_PLAN_PAGOS' (state, planPagos) {
        state.planesPagos.push(planPagos);

        if (state.planesPagos.length != 0) {
            state.importePlanesPagosPesos = state.planesPagos
                // .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importePlanesPagosPesos = 0;
        }
    },
    'DELETE_PLAN_PAGOS' (state, planPagos) {
        let itemKey = state.planesPagos
            .findIndex(item => item == planPagos);

        if (itemKey != -1) {
            state.planesPagos.splice(itemKey, 1);
        }

        if (state.planesPagos.length != 0) {
            state.importePlanesPagosPesos = state.planesPagos
                // .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importePlanesPagosPesos = 0;
        }
    },
    'SET_RETENCIONES_CLIENTES' (state, retencionesClientes) {
        state.retencionesClientes = retencionesClientes;

        state.importeRetencionesClientes = 0;
        if (state.retencionesClientes.length != 0) {
            state.importeRetencionesClientesPesos = state.retencionesClientes
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeRetencionesClientesPesos = 0;
        }
    },

    'SET_TARJETA_CUPON' (state, tarjetaCupon) {
        tarjetaCupon.proveedorId = state.proveedorId;
        tarjetaCupon.proveedor = state.proveedor;
        
        state.tarjetasCupones.push(tarjetaCupon);

        if (state.tarjetasCupones.length != 0) {
            state.importeTarjetasCuponesPesos = state.tarjetasCupones
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeTarjetasCuponesDolares = state.tarjetasCupones
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeTarjetasCuponesPesos = 0;
            state.importeTarjetasCuponesDolares = 0;
        }
    },
    'DELETE_TARJETA_CUPON' (state, tarjetaCupon) {
        let itemKey = state.tarjetasCupones
            .findIndex(cupon => cupon == tarjetaCupon);

        if (itemKey != -1) {
            state.tarjetasCupones.splice(itemKey, 1);
        }

        if (state.tarjetasCupones.length != 0) {
            state.importeTarjetasCuponesPesos = state.tarjetasCupones
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeTarjetasCuponesDolares = state.tarjetasCupones
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeTarjetasCuponesPesos = 0;
            state.importeTarjetasCuponesDolares = 0;
        }
    },

    'SET_RETENCION_PROVEEDOR' (state, retencionProveedor) {
        retencionProveedor.proveedorId = state.proveedorId;
        retencionProveedor.proveedor = state.proveedor;
        
        state.retencionesProveedores.push(retencionProveedor);

        if (state.retencionesProveedores.length != 0) {
            state.importeRetencionesProveedoresPesos = state.retencionesProveedores
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeRetencionesProveedoresPesos = 0;
        }
    },
    'DELETE_RETENCION_PROVEEDOR' (state, retencionProveedor) {
        let itemKey = state.retencionesProveedores
            .findIndex(rp => rp == retencionProveedor);

        if (itemKey != -1) {
            state.retencionesProveedores.splice(itemKey, 1);
        }

        if (state.retencionesProveedores.length != 0) {
            state.importeRetencionesProveedoresPesos = state.retencionesProveedores
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeRetencionesProveedoresPesos = 0;
        }
    },

    'SET_CUENTA_CORRIENTE_SALDO' (state) {
        state.cuentaCorrienteSaldoId = 0;

        let saldo = getSaldo(state);

        if (saldo > 0) {
            /* Saldo en uno de los comprobantes incluidos */
            let cuentaCorriente = state.cuentaCorriente
                .filter(cuentaCorriente => cuentaCorriente.selected)
                .reduce(function(prev, current) {
                    return (prev.saldo > current.saldo) ? prev : current
                }, 0);            

            if (cuentaCorriente) {
                if ((cuentaCorriente.saldo * state.cotizacion) >= saldo) {
                    /* Verificamos que el saldo del comprobante sea mayor al saldo del recibo */
                    state.cuentaCorrienteSaldoId = cuentaCorriente.id;
                }
            }
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.pagoDatos = [];
        state.pagoComprobantes = [];
        state.pagoCuotas = [];
        state.pagoDocumentos = [];
        state.pagoChequesPropios = [];
        state.pagoTarjetasCupones = [];
        state.pagoTransferenciasProveedores = [];
        state.pagoRetencionesProveedores = [];
        state.pagoVeps = [];
        state.pagoPlanesPagos = [];
    },
    'SET_PAGO_DATOS' (state, params) {
        state.pagoDatos = params.pagoDatos;
        state.pagoComprobantes = params.pagoComprobantes;
        state.pagoCuotas = params.pagoCuotas;
        state.pagoDocumentos = params.pagoDocumentos;
        state.pagoChequesPropios = params.pagoChequesPropios;
        state.pagoTarjetasCupones = params.pagoTarjetasCupones;
        state.pagoTransferenciasProveedores = params.pagoTransferenciasProveedores;
        state.pagoRetencionesProveedores = params.pagoRetencionesProveedores;
        state.pagoVeps = params.pagoVeps;
        state.pagoPlanesPagos = params.pagoPlanesPagos;
    },
};

function inicializarDocumentos (state) {
    state.pesos = 0;
    state.importeChequesPropiosPesos = 0;
    state.importeChequesPropiosDolares = 0;
    state.importeTransferenciasProveedoresPesos = 0;
    state.importeTransferenciasProveedoresDolares = 0;
    state.importePagosVepPesos = 0;
    state.importePagosVepDolares = 0;
    state.importeTarjetasCuponesPesos = 0;
    state.importeTarjetasCuponesDolares = 0;
    state.importePlanesPagosPesos = 0;
    state.importePlanesPagosDolares = 0;
    state.importeRetencionesClientesPesos = 0;
    state.importeRetencionesProveedoresPesos = 0;
    
    state.chequesPropios = [];
    state.transferenciasProveedores = [];
    state.tarjetasCupones = [];
    state.pagosVep = [];
    state.planesPagos = [];
    state.retencionesClientes = [];
    state.retencionesProveedores = [];
}

function getTotalDocumentos (state) {
    if (state.monedaId == 101) {
        return parseFloat(state.pesos) 
            + parseFloat(state.importeChequesPropiosPesos)
            + parseFloat(state.importeChequesPropiosDolares) * parseFloat(state.cotizacion)
            + parseFloat(state.importeTransferenciasProveedoresPesos)
            + parseFloat(state.importeTransferenciasProveedoresDolares) * parseFloat(state.cotizacion)
            + parseFloat(state.importePagosVepPesos)
            + parseFloat(state.importePagosVepDolares) * parseFloat(state.cotizacion)
            + parseFloat(state.importeTarjetasCuponesPesos)
            + parseFloat(state.importeTarjetasCuponesDolares) * parseFloat(state.cotizacion)
            + parseFloat(state.importePlanesPagosPesos)
            + parseFloat(state.importePlanesPagosDolares) * parseFloat(state.cotizacion)
            + parseFloat(state.importeRetencionesClientesPesos)
            + parseFloat(state.importeRetencionesProveedoresPesos);
    }

    if (state.monedaId == 102) {
        return parseFloat(state.pesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importeChequesPropiosPesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importeChequesPropiosDolares)
            + parseFloat(state.importeTransferenciasProveedoresPesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importeTransferenciasProveedoresDolares)
            + parseFloat(state.importePagosVepPesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importePagosVepDolares)
            + parseFloat(state.importeTarjetasCuponesPesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importeTarjetasCuponesDolares)
            + parseFloat(state.importePlanesPagosPesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importePlanesPagosDolares)
            + parseFloat(state.importeRetencionesClientesPesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importeRetencionesProveedoresPesos) / parseFloat(state.cotizacion);
    }

    return parseFloat(state.pesos) 
        + parseFloat(state.importeChequesPropiosPesos)
        + parseFloat(state.importeChequesPropiosPesosDolares)
        + parseFloat(state.importeTransferenciasProveedoresPesos)
        + parseFloat(state.importeTransferenciasProveedoresDolares)
        + parseFloat(state.importePagosVepPesos)
        + parseFloat(state.importePagosVepDolares)
        + parseFloat(state.importeTarjetasCuponesPesos)
        + parseFloat(state.importeTarjetasCuponesDolares)
        + parseFloat(state.importePlanesPagosPesos)
        + parseFloat(state.importePlanesPagosDolares)
        + parseFloat(state.importeRetencionesClientesPesos)
        + parseFloat(state.importeRetencionesProveedoresPesos);
}

function getSaldo (state) {
    // console.log('totalSeleccionado', state.totalSeleccionado);

    return parseFloat(state.totalSeleccionado) - getTotalDocumentos(state);
}

function calcularTotalesCuentaCorriente (state) {
    state.totalSeleccionado = 0;
    state.cantidadSeleccionados = 0;

    state.totalCuentaCorrientePesos = 0;
    state.totalSeleccionadoPesos = 0;
    state.totalCuentaCorrienteDolares = 0;
    state.totalSeleccionadoDolares = 0;

    state.totalSeleccionado = state.cuentaCorriente
        .reduce((a, b) => a + ( b.selected ? b.saldo : 0 ), 0);

    state.cantidadSeleccionados = state.cuentaCorriente
        .reduce((a, b) => a + ( b.selected ? 1 : 0 ), 0);

    state.totalCuentaCorrientePesos = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 101 ? b.saldo : 0), 0);
    state.totalSeleccionadoPesos = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 101 & b.selected ? b.saldo : 0), 0);

    state.totalCuentaCorrienteDolares = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 102 ? b.saldo : 0), 0);
    state.totalSeleccionadoDolares = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 102 & b.selected ? b.saldo : 0), 0);
}

function calcularTotalesCuotas (state) {
    state.totalSeleccionado = 0;
    state.cantidadSeleccionados = 0;

    state.totalCuentaCorrientePesos = 0;
    state.totalSeleccionadoPesos = 0;
    state.totalCuentaCorrienteDolares = 0;
    state.totalSeleccionadoDolares = 0;

    state.totalSeleccionado = state.planPagoCuotas
        .reduce((a, b) => a + ( b.capitalSelected ? b.importeCapital : 0 )
            + ( b.interesesSelected ? b.importeIntereses : 0 )
            + ( b.interesesResarcitoriosSelected ? b.importeInteresesResarcitorios : 0 ), 0);

    state.cantidadSeleccionados = state.planPagoCuotas
        .reduce((a, b) => a + ( b.capitalSelected || b.interesesSelected || b.interesesResarcitoriosSelected ? 1 : 0 ), 0);

    state.totalCuentaCorrientePesos = state.planPagoCuotas
        .reduce((a, b) => a + (state.monedaId == 101 ? b.importeCapital + b.importeIntereses + b.importeInteresesResarcitorios : 0), 0);

    state.totalSeleccionadoPesos = helpers.methods.roundToTwo(state.planPagoCuotas
        .reduce((a, b) => a + (state.monedaId == 101 & b.capitalSelected ? b.importeCapital : 0)
            + (state.monedaId == 101 & b.interesesSelected ? b.importeIntereses : 0)
            + (state.monedaId == 101 & b.interesesResarcitoriosSelected ? b.importeInteresesResarcitorios : 0), 0));

    state.totalCuentaCorrienteDolares = state.planPagoCuotas
        .reduce((a, b) => a + (state.monedaId == 102 ? b.importeCapital + b.importeIntereses + b.importeInteresesResarcitorios : 0), 0);

    state.totalSeleccionadoDolares = helpers.methods.roundToTwo(state.planPagoCuotas
        .reduce((a, b) => a + (state.monedaId == 102 & b.capitalSelected ? b.importeCapital : 0)
            + (state.monedaId == 102 & b.interesesSelected ? b.importeIntereses : 0)
            + (state.monedaId == 102 & b.interesesResarcitoriosSelected ? b.importeInteresesResarcitorios : 0), 0));
}

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PAGO', params);

             /* Recuperamos la caja central */
             apiAxios.get('cajas/central')
                .then((res) => {
                    commit("SET_CAJA_REGISTRO", res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    inicializarPagoCuotas ( { commit }, planPagosId ) {
        return new Promise((resolve, reject) => {
            let params = {
                pagoImpuestos: Boolean(false),
                pagoCuotasPlan: Boolean(true),
                planPagosId
            };

            commit('INICIALIZAR_PAGO', params);

             /* Recuperamos la caja central */
             apiAxios.get('cajas/central')
                .then((res) => {
                    commit("SET_CAJA_REGISTRO", res.data);
                    
                    /* Recuperamos la informacion del plan de pagos y las cuotas */
                    return apiAxios.get(`planespagos/${planPagosId}/pago`);
                })
                .then((res) => {
                    commit('SET_PLAN', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    setCuentaCorrienteSaldo ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('SET_CUENTA_CORRIENTE_SALDO');
            resolve();
        })            
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            let totalDocumentos = getTotalDocumentos(state);
            let saldo = getSaldo(state);

            if (totalDocumentos == 0 && parseFloat(state.totalSeleccionado) == 0) {
                save = false;
                errorMessage = "El total de documentos incluidos en el pago, y los comprobantes seleccionados, no puede ser igual a cero."
            }

            if (!state.pagoCuotasPlan) {
                /* Validamos si se pudo dejar el saldo en un comprobante */
                commit('SET_CUENTA_CORRIENTE_SALDO');
                
                if (saldo > 0) {
                    /* Verificamos si se seleccionó un comprobante para el saldo del pago */
                    if (state.cuentaCorrienteSaldoId == 0) {
                        save = false;
                        errorMessage = "No se pudo seleccionar un comprobante con saldo suficiente para asignar el saldo de la orden de pago."
                    }
                }
            }

            if (save) {
                let selected = [];
                state.cuentaCorriente.forEach(cuentaCorriente => {
                    if ((/true/i).test(cuentaCorriente.selected)) {
                        let item = {
                            cuentaCorrienteProveedorId: parseInt(cuentaCorriente.id),
                            rowVersion: cuentaCorriente.rowVersion,
                        }
                        selected.push(item);
                    }
                });

                let cuotas = [];
                state.planPagoCuotas.forEach(planPagosCuota => {
                    if ((/true/i).test(planPagosCuota.capitalSelected)
                            || (/true/i).test(planPagosCuota.interesesSelected)
                            || (/true/i).test(planPagosCuota.interesesResarcitoriosSelected)) {
                        let item = {
                            planPagosCuotaId: parseInt(planPagosCuota.id),
                            importeCapital: (/true/i).test(planPagosCuota.capitalSelected) ? parseFloat(planPagosCuota.importeCapital) : 0,
                            importeIntereses: (/true/i).test(planPagosCuota.interesesSelected) ? parseFloat(planPagosCuota.importeIntereses) : 0,
                            importeInteresesResarcitorios: (/true/i).test(planPagosCuota.interesesResarcitoriosSelected) ? parseFloat(planPagosCuota.importeInteresesResarcitorios) : 0,
                            rowVersion: planPagosCuota.rowVersion,
                        }
                        cuotas.push(item);
                    }
                });

                let pago= {
                    fechaContable: moment(state.fechaContable).format('YYYY-MM-DD'),
                    proveedorId: parseInt(state.proveedorId),
                    planPagosId: parseInt(state.planPagosId),
                    monedaId: parseInt(state.monedaId),
                    cotizacion: parseFloat(state.cotizacion),
                    observaciones: state.observaciones.trim(),
                    pagosCuentaCorriente: selected,
                    planPagosCuotas: cuotas
                };
                
                let retencionesClientes = state.retencionesClientes.map(retencionCliente => ({
                    retencionClienteId: retencionCliente.id,
                    importe: retencionCliente.importe
                }))

                let ordenPago = {
                    pago: pago,
                    pesos: parseFloat(state.pesos),
                    transferenciasProveedores: state.transferenciasProveedores.map(item => ({
                        fechaCreditoDebito: moment(item.fechaCreditoDebito).format('YYYY-MM-DD'),
                        bancoCuentaId: item.bancoCuentaId,
                        monedaId: item.monedaId,
                        importe: parseFloat(item.importe),
                    })),
                    chequesPropios: state.chequesPropios.map(item => ({
                        fechaEmision: moment(item.fechaEmision).format('YYYY-MM-DD'),
                        fechaPago: moment(item.fechaPago).format('YYYY-MM-DD'),
                        bancoCuentaId: item.bancoCuentaId,
                        monedaId: item.monedaId,
                        proveedorId: item.proveedorId,
                        numero: item.numero,
                        importe: parseFloat(item.importe),
                    })),
                    pagosVep: state.pagosVep.map(item => ({
                        fechaCreditoDebito: moment(item.fechaCreditoDebito).format('YYYY-MM-DD'),
                        bancoCuentaId: item.bancoCuentaId,
                        monedaId: item.monedaId,
                        importe: parseFloat(item.importe),
                    })),
                    tarjetasCupones: state.tarjetasCupones.map(item => ({
                        proveedorId: item.proveedorId,
                        tarjetaPlasticoId: item.tarjetaPlasticoId,
                        monedaId: item.monedaId,
                        loteNumero: item.loteNumero,
                        cuponNumero: item.cuponNumero,
                        fechaCupon: moment(item.fechaCupon).format('YYYY-MM-DD'),
                        cuotas: item.cuotas,
                        importe: parseFloat(item.importe),
                    })),
                    planesPagos: state.planesPagos.map(item => ({
                        numero: item.numero,
                        fechaVencimientoInicial: moment(item.fechaVencimientoInicial).format('YYYY-MM-DD'),
                        bancoCuentaId: item.bancoCuentaId,
                        cantidadCuotas: item.cantidadCuotas,
                        importe: parseFloat(item.importe),
                        intereses: parseFloat(item.interes)
                    })),
                    retencionesClientes,
                    retencionesProveedores: state.retencionesProveedores.map(item => ({
                        fechaComprobante: moment(item.fechaComprobante).format('YYYY-MM-DD'),
                        retencionTipoId: item.retencionTipoId,
                        retencionRegimenId: item.retencionRegimenId,
                        importe: parseFloat(item.importe),
                    })),
                    cajaRegistroId: state.cajaRegistroId,
                    cuentaCorrienteProveedorId: state.cuentaCorrienteSaldoId
                };
                
                let url = state.controller;

                if (state.pagoCuotasPlan) {
                    url = 'pagos/cuotas-plan'
                }

                apiAxios.post(url, ordenPago)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },

    setProveedor: ({ commit, state }, proveedor) => {
        return new Promise((resolve, reject) => {
            commit('SET_PROVEEDOR', proveedor);

            let getDeuda = false;
            if (proveedor != null) {
                if (proveedor.id != 0) {
                    getDeuda = true;
                }
            }
            if (getDeuda) {
                let queryString = '';
                if ((/true/i).test(state.pagoImpuestos)) {
                    if ((/true/i).test(state.incluirImpuestosOrganismo)) {
                        queryString = '?incluirImpuestosOrganismo=true';
                    }
                }

                apiAxios.get(`cuentacorrienteproveedores/${proveedor.id}/deuda` + queryString) 
                    .then(res => {
                        commit('SET_CUENTA_CORRIENTE', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();        
            }
        })
    },
    getDeudaProveedor: ({ commit, state }) => {
        return new Promise((resolve, reject) => {
            let getDeuda = false;
            if (state.proveedor != null) {
                if (state.proveedor.id != 0) {
                    getDeuda = true;
                }
            }
            if (getDeuda) {
                let queryString = '';
                if ((/true/i).test(state.pagoImpuestos)) {
                    if ((/true/i).test(state.incluirImpuestosOrganismo)) {
                        queryString = '?incluirImpuestosOrganismo=true';
                    }
                }

                apiAxios.get(`cuentacorrienteproveedores/${state.proveedor.id}/deuda` + queryString) 
                    .then(res => {
                        commit('SET_CUENTA_CORRIENTE', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();        
            }
        })
    },
    setCajaRegistro ( { commit }, cajaRegistro ) {
        commit('SET_CAJA_REGISTRO', cajaRegistro);
    },
    setTransferenciaProveedor ( { commit }, transferenciaProveedor ) {
        commit('SET_TRANSFERENCIA_PROVEEDOR', transferenciaProveedor);
    },
    deleteTransferenciaProveedor ( { commit }, transferenciaProveedor ) {
        commit('DELETE_TRANSFERENCIA_PROVEEDOR', transferenciaProveedor);
    },
    setPagoVep ( { commit }, pagoVep ) {
        commit('SET_PAGO_VEP', pagoVep);
    },
    deletePagoVep ( { commit }, pagoVep ) {
        commit('DELETE_PAGO_VEP', pagoVep);
    },
    setChequePropio ( { commit }, chequePropio ) {
        commit('SET_CHEQUE_PROPIO', chequePropio);
    },
    deleteChequePropio ( { commit }, chequePropio ) {
        commit('DELETE_CHEQUE_PROPIO', chequePropio);
    },
    setTarjetaCupon ( { commit }, tarjetaCupon ) {
        commit('SET_TARJETA_CUPON', tarjetaCupon);
    },
    deleteTarjetaCupon ( { commit }, tarjetaCupon ) {
        commit('DELETE_TARJETA_CUPON', tarjetaCupon);
    },
    setPlanPagos ( { commit }, planPagos ) {
        commit('SET_PLAN_PAGOS', planPagos);
    },
    deletePlanPagos ( { commit }, planPagos ) {
        commit('DELETE_PLAN_PAGOS', planPagos);
    },
    setRetencionesClientes ( { commit }, retencionesSeleccionadas ) {
        commit('SET_RETENCIONES_CLIENTES', retencionesSeleccionadas);
    },
    setRetencionProveedor ( { commit }, retencionProveedor ) {
        commit('SET_RETENCION_PROVEEDOR', retencionProveedor);
    },
    deleteRetencionProveedor ( { commit }, retencionProveedor ) {
        commit('DELETE_RETENCION_PROVEEDOR', retencionProveedor);
    },

    seleccionarCuentaCorriente ( { commit }, cuentaCorrienteId ) {
        return new Promise((resolve, reject) => {
            commit('SELECCIONAR_CUENTA_CORRIENTE', cuentaCorrienteId);
            resolve();
        })
    },
    validarMoneda ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('VALIDAR_MONEDA');
            resolve();
        })
    },
    seleccionarCuota ( { commit }, planPagosCuotaId ) {
        return new Promise((resolve, reject) => {
            commit('SELECCIONAR_CUOTA', planPagosCuotaId);
            resolve();
        })
    },

    getDatos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (params.pagoId) {
                let url = 'pagos';
                if ((/true/i).test(params.impuestos)) {
                    url = 'pagos-impuestos';
                }

                apiAxios.get(url + '/' + params.pagoId ) 
                    .then(res => {
                        let pagoDatos = [];

                        let total = helpers.methods.formattedMoneda(res.data.total, res.data.moneda);
                        let saldo = helpers.methods.formattedMoneda(res.data.saldo, res.data.moneda);

                        if ((/true/i).test(params.impuestos)) {
                            pagoDatos = [
                                { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                                { 'nombre': 'impuestoOrganismo', 'campo': 'Organismo', 'valor': res.data.impuestoOrganismo, 'formato': '' },
                                { 'nombre': 'proveedor', 'campo': 'Impuesto', 'valor': res.data.proveedor, 'formato': '' },
                            ];

                            if (res.data.planPagosId != 0) {
                                pagoDatos.push(
                                    { 'nombre': 'planPagosNumero', 'campo': 'Nro.Plan de Pagos', 'valor': res.data.planPagosNumero, 'formato': '' },
                                );
                            }

                            pagoDatos.push(
                                { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' },
                                { 'nombre': 'saldo', 'campo': 'Saldo', 'valor': saldo, 'formato': '' },
                                { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' },
                            );
                        } else {
                            pagoDatos = [
                                { 'nombre': 'numero', 'campo': 'Nro. Orden', 'valor': res.data.numero, 'formato': '' },
                                { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                                { 'nombre': 'fechaContable', 'campo': 'Fecha Contable', 'valor': res.data.fechaContable, 'formato': 'fecha' },
                                { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                                { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' },
                                { 'nombre': 'saldo', 'campo': 'Saldo', 'valor': saldo, 'formato': '' },
                            ]

                            if (res.data.monedaId != 101) {
                                pagoDatos.push({ 'nombre': 'cotizacion', 'campo': `Cotización ${res.data.monedaAbreviacion}`, 'valor': res.data.cotizacion, 'formato': 'moneda' });
                            }

                            pagoDatos.push({ 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' });
                        }                        

                        let paramsDatos = {
                            pagoDatos,
                            pagoComprobantes: res.data.comprobantes,
                            pagoCuotas: res.data.cuotas,
                            pagoDocumentos: res.data.documentos,
                            pagoChequesPropios: res.data.chequesPropios,
                            pagoTarjetasCupones: res.data.tarjetasCupones,
                            pagoTransferenciasProveedores: res.data.transferenciasProveedores,
                            pagoRetencionesProveedores: res.data.retencionesProveedores,
                            pagoVeps: res.data.veps,
                            pagoPlanesPagos: res.data.planesPagos
                        }
                                      
                        commit('SET_PAGO_DATOS', paramsDatos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}